import "../../arDominionB5Plugin/js/main";

/*

Extra/custom JS:

jQuery, $ and bootstrap are exposed globally. Also Drupal and Qubit,
but avoid its usage. Allows IIFEs, CommonJS, ES6 Modules and it could
allow Typescript if it's implemented in the Webpack build process.

*/


$(function() {

    $('.cubo').each(function(index, value) {
        $( this ).css("background-image", "url(" + $( this ).attr("fondo") + ")");
    });

});

document.addEventListener( 'DOMContentLoaded', function() {
    var splide = new Splide( '.splide' );
    splide.mount();
} );